class SwiperComponent extends HTMLElement {
    constructor() {
      super();
      this.swiperElement = this;

      this.enableScrollbar = this.hasAttribute('data-enable-scrollbar') || false;
      this.enablePagination = this.hasAttribute('data-enable-pagination') || false;
      this.customOptionsData = this.getAttribute('data-options');
      this.customOptions = null;

      this.baseOptions = {
        slidesPerView: 2,
        spaceBetween: 16,
        resistanceRatio: 0.68,
        simulateTouch: true,
        allowTouchMove: true,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next') || this.querySelector('.swiper-btn-next'),
          prevEl: this.querySelector('.swiper-button-prev') || this.querySelector('.swiper-btn-prev'),
        },
        ...(this.enablePagination
          ? {
              pagination: {
                el: this.querySelector('.swiper-pagination'),
              },
            }
          : {}),
        ...(this.enableScrollbar
          ? {
              scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
                draggable: true,
              },
            }
          : {}),
      };
    }

    get options() {
      if (this._cachedOptions) return this._cachedOptions;

      this._cachedOptions = { ...this.baseOptions };
      if (this.customOptionsData) {
        try {
          const parsed = JSON.parse(this.customOptionsData);
          this._cachedOptions = { ...this._cachedOptions, ...parsed };
        } catch (error) {
          console.error('Error parsing custom options:', error);
        }
      }

      return this._cachedOptions;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      this.swiper = new Swiper(this.swiperElement, this.options);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  customElements.define('swiper-component', SwiperComponent);

  class BreakpointSwiper extends SwiperComponent {
    constructor() {
      super();

      this.onlyFor = this.getAttribute('data-only-for') || 'mobile';
      this.mediaToWatch = this.getAttribute('data-media-to-watch') || 990;

      this.mql = window.matchMedia(`(min-width: ${this.mediaToWatch}px)`);
      this.mql.addEventListener('change', this.onMediaChange.bind(this));
    }

    connectedCallback() {
      const mediaMatches = this.mql.matches;
      const shouldInit = this.onlyFor === 'desktop' ? mediaMatches : !mediaMatches;

      if (!shouldInit) return;

      super.connectedCallback();
    }

    onMediaChange() {
      const mediaMatches = this.mql.matches; // true = desktop, false = mobile

      // Determine if swiper should be active based on device type and breakpoint
      const shouldBeActive = this.onlyFor === 'desktop' ? mediaMatches : !mediaMatches;

      if (shouldBeActive && !this.swiper) {
        this.initSwiper();
      } else if (!shouldBeActive && this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  customElements.define('breakpoint-swiper', BreakpointSwiper);
